/**
 * Client Entry Point
 *
 * Renders the full React app on the client side.
 * Server provides SEO meta tags, client renders the full UI.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { Providers } from './providers';
import './index.css';

// Use createRoot since server only renders SEO shell, not full app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
